// releaseChannel.js
// ============================================================================
// Which feature channel this build runs on — 'dev' (everything) vs 'release'
// (only what HowTo-Backend/config/release_manifest.json ships). The manifest
// is served at GET /api/release/manifest as { surfaces, automations }.
//
// Channel rules:
//   • localStorage 'aria_channel' = 'dev' | 'release' → explicit override
//   • else the Electron desktop app (window.electronAPI) → 'dev'
//   • else (hosted web) → 'release'
// ============================================================================

import { getApiBase } from './apiBase';

let _manifest = null;   // cached manifest once fetched
let _inflight = null;   // dedupe concurrent fetches

export function getChannel() {
  try {
    const forced = localStorage.getItem('aria_channel');
    if (forced === 'dev' || forced === 'release') return forced;
  } catch (_) {}
  if (typeof window !== 'undefined' && window.electronAPI) return 'dev';
  return 'release';
}

// Fetch the release manifest once (cached for the session). Resolves to the
// manifest object or null if the server is unreachable — callers fail OPEN
// (show the feature) on null so a network blip never blanks the page.
export function loadManifest() {
  if (_manifest) return Promise.resolve(_manifest);
  if (_inflight) return _inflight;
  _inflight = fetch(`${getApiBase()}/api/release/manifest`)
    .then((r) => r.json())
    .then((m) => { _manifest = (m && (m.surfaces || m.automations)) ? m : null; return _manifest; })
    .catch(() => null)
    .finally(() => { _inflight = null; });
  return _inflight;
}

export function getManifest() { return _manifest; }
